import { filterNumber } from './helper';
export class Phone {
    formatResult = '';
    formatExt = '';
    formatPhone = '';
    phoneValue = '';
    extValue = '';
    value = '';
}
export function buildPhone(phone, ext) {
    phone += '';
    ext += '';
    const part1 = filterNumber(phone);
    // (___) ___-____
    const p1 = part1.slice(0, 3);
    const p2 = part1.slice(3, 6);
    const p3 = part1.slice(6, 10);
    let format = '';
    if (p1)
        format = '(' + p1;
    if (p2)
        format += ') ' + p2;
    if (p3)
        format += '-' + p3;
    const part2 = filterNumber(ext);
    const result = new Phone();
    result.phoneValue = part1;
    result.extValue = part2;
    result.formatPhone = format;
    result.formatExt = part2;
    result.formatResult = format;
    result.value = part1;
    if (part2) {
        result.formatResult = `${format} x ${part2}`;
        result.value = `${part1}x${part2}`;
    }
    return result;
}
export function decodePhone(phone) {
    if (phone) {
        const segments = phone.split('x');
        return buildPhone(segments[0], segments[1]);
    }
    return new Phone();
}
